import { Loader2, Lock } from "lucide-react";
import React, { useState } from "react";
import { Modal } from "@/components/_shared/Modal";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

interface RoomPasswordModalProps {
	isOpen: boolean;
	onClose: () => void; // Usually navigates back if closed without success
	onSubmit: (password: string) => void;
	error?: string | null;
	isLoading?: boolean;
}

export function RoomPasswordModal({
	isOpen,
	onClose,
	onSubmit,
	error,
	isLoading = false,
}: RoomPasswordModalProps) {
	const [password, setPassword] = useState("");

	const handleSubmit = () => {
		if (!password || isLoading) return;
		onSubmit(password);
	};

	return (
		<Modal
			closeOnOutsideClick={false}
			isOpen={isOpen}
			onClose={onClose}
			title="Passwortgeschützter Raum" // Prevent closing by clicking outside
		>
			<div className="space-y-4 p-2">
				<div className="mb-2 flex items-center rounded-lg border border-amber-100 bg-amber-50 p-3 text-amber-800 dark:border-amber-800/30 dark:bg-amber-900/30 dark:text-amber-300">
					<Lock className="mr-2 h-5 w-5 shrink-0" />
					<p>
						Dieser FileShare-Raum ist passwortgeschützt. Bitte gib das Passwort
						ein, um auf die Dateien zuzugreifen.
					</p>
				</div>

				{error && (
					<p className="text-red-500 text-sm dark:text-red-400">{error}</p>
				)}

				<Input
					autoFocus
					className="w-full border-gray-200 bg-white dark:border-gray-600 dark:bg-gray-700"
					disabled={isLoading}
					onChange={(e) => setPassword(e.target.value)}
					onKeyDown={(e) => e.key === "Enter" && handleSubmit()}
					placeholder="Passwort eingeben"
					type="password"
					value={password}
				/>

				<div className="mt-4 flex justify-end space-x-2">
					<Button
						className="dark:border-gray-600"
						disabled={isLoading}
						onClick={onClose}
						type="button"
						variant="outline"
					>
						Abbrechen
					</Button>
					<Button
						disabled={isLoading || !password}
						onClick={handleSubmit}
						type="button"
					>
						{isLoading ? (
							<>
								<Loader2 className="mr-2 h-4 w-4 animate-spin" /> Prüfen...
							</>
						) : (
							"Zugreifen"
						)}
					</Button>
				</div>
			</div>
		</Modal>
	);
}
